import { MantineTheme } from "@mantine/core";
import { DataMapMarkerProps, latLng, ValuesRecord } from "@mcurros2/microm";
import { moodSmileIcon } from "../../MapMarkerIcons/MapMarkerIcons";


export function HistorialCheckinVerUbicacionViewMarkerRenderer(record: ValuesRecord, position: latLng, theme: MantineTheme): DataMapMarkerProps | null {

    const personal = record[0] as string;

    const color = theme.colors.green[6];
    const icon = moodSmileIcon;

    const markerProps: DataMapMarkerProps = {
        position: position,
        title: `${personal}`,
        svgIcon: icon,
        assignColorByValue: undefined,
        fillColor: color,
    }

    return markerProps;
}